import { render, staticRenderFns } from "./CommonMember.vue?vue&type=template&id=181deb4b&scoped=true&"
import script from "./CommonMember.vue?vue&type=script&lang=js&"
export * from "./CommonMember.vue?vue&type=script&lang=js&"
import style0 from "./CommonMember.vue?vue&type=style&index=0&id=181deb4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181deb4b",
  null
  
)

export default component.exports